import { Chip, Divider, FormControlLabel, Grid, Switch, TextField, Typography } from '@material-ui/core';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { InfoDot } from './info-dot';
/**
 * Top-level journey bucket header (Invite / Verification / Account settings).
 * Sits above the finer-grained SectionHeaders within each bucket.
 */
export const BucketHeader = ({ expanded, onClick, subtitle, title }) => (React.createElement(Grid, { item: true, style: { marginTop: 32 }, xs: 12 },
    React.createElement("div", { onClick: onClick, style: {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
            gap: 6
        } },
        React.createElement(ExpandMore, { style: {
                fontSize: 26,
                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s'
            } }),
        React.createElement("div", null,
            React.createElement(Typography, { style: { fontWeight: 700 }, variant: "h6" }, title),
            subtitle && (React.createElement(Typography, { color: "textSecondary", variant: "body2" }, subtitle)))),
    React.createElement(Divider, { style: { background: 'rgba(0,0,0,0.24)', height: 2, marginTop: 8 } })));
export const SectionHeader = ({ info, title }) => (React.createElement(Grid, { item: true, style: { marginTop: 16 }, xs: 12 },
    React.createElement(Typography, { style: {
            alignItems: 'center',
            display: 'flex',
            fontWeight: 600,
            gap: 6,
            marginBottom: 4
        }, variant: "subtitle2" },
        title,
        info && React.createElement(InfoDot, { info: info })),
    React.createElement(Divider, null)));
/**
 * Indented container for controls revealed under an enabled parent toggle
 * (progressive disclosure). Renders a nested Grid so Toggle/TextInput children
 * lay out normally.
 */
export const RevealGroup = ({ children }) => (React.createElement(Grid, { item: true, xs: 12 },
    React.createElement("div", { style: {
            borderLeft: '2px solid rgba(0,0,0,0.12)',
            marginLeft: 12,
            paddingLeft: 16
        } },
        React.createElement(Grid, { container: true, spacing: 2 }, children))));
/**
 * Zero-height, full-width grid item that forces the items after it onto a new
 * row (used to start an expanded product on its own line and to separate a
 * block of toggles from the inputs that follow).
 */
export const RowBreak = () => (React.createElement(Grid, { item: true, style: { height: 0, padding: 0 }, xs: 12 }));
export const CollapsibleSectionHeader = ({ expanded, info, onClick, title }) => (React.createElement(Grid, { item: true, style: { marginTop: 16 }, xs: 12 },
    React.createElement("div", { style: { alignItems: 'center', display: 'flex', gap: 6 } },
        React.createElement("div", { onClick: onClick, style: { alignItems: 'center', cursor: 'pointer', display: 'flex' } },
            React.createElement(ExpandMore, { style: {
                    fontSize: 22,
                    marginRight: 4,
                    transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s'
                } }),
            React.createElement(Typography, { style: { fontWeight: 600 }, variant: "subtitle2" }, title)),
        info && React.createElement(InfoDot, { info: info })),
    React.createElement(Divider, { style: { marginTop: 4 } })));
export const EmailChipInput = ({ disabled, info, label, onChange, value }) => (React.createElement(Autocomplete, { disabled: disabled, freeSolo: true, multiple: true, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (_, newValue) => {
        onChange(newValue.map(String));
    }, options: [], renderInput: (params) => (React.createElement(TextField, { ...params, label: React.createElement("span", { style: { alignItems: 'center', display: 'inline-flex', gap: 4 } },
            label,
            info && React.createElement(InfoDot, { info: info })) })), renderTags: (tagValue, getTagProps) => tagValue.map((email, index) => (React.createElement(Chip, { key: email, label: React.createElement("span", { "data-ph-mask": true, style: { fontSize: '1.2rem' } }, email), ...getTagProps({ index }) }))), value: value }));
/** Full-width inline warning callout, e.g. to flag a billable side effect. */
export const InlineWarning = ({ children }) => (React.createElement(Grid, { item: true, xs: 12 },
    React.createElement("div", { style: {
            background: 'rgba(237,108,2,0.08)',
            border: '1px solid rgba(237,108,2,0.5)',
            borderRadius: 4,
            color: '#8a4b00',
            display: 'flex',
            fontSize: 13,
            gap: 8,
            lineHeight: 1.4,
            padding: '8px 12px'
        } },
        React.createElement("span", { "aria-hidden": true, style: { fontWeight: 700 } }, "\u26A0"),
        React.createElement("span", null, children))));
export const Toggle = ({ checked, disabled, info, label, onChange }) => (React.createElement(Grid, { item: true, md: 4, sm: 6, xs: 12 },
    React.createElement(FormControlLabel, { control: React.createElement(Switch, { checked: checked, disabled: disabled, onChange: onChange, size: "small" }), disabled: disabled, label: React.createElement("span", { style: { alignItems: 'center', display: 'inline-flex', gap: 6 } },
            label,
            info && React.createElement(InfoDot, { info: info })) })));
